<template>
  <section id="alerts">
    <div class="demo">
      <div class="alert alert-info alert-dismissible fade show" role="alert">
        <i class="gel-icon-info" aria-hidden="true"></i>
        A simple primary alert with
        <a href="#" class="alert-link">an example link</a>. Give it a click if you like.
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <i class="gel-icon-close gel-icon-lg" aria-hidden="true"></i>
        </button>
      </div>
      <div class="alert alert-success alert-dismissible fade show" role="alert">
        <i class="gel-icon-tick-circle"></i> This is a success alert—check it out!
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <i class="gel-icon-close gel-icon-lg" aria-hidden="true"></i>
        </button>
      </div>
      <div class="alert alert-danger" role="alert">
        <i class="gel-icon-error" aria-hidden="true"></i>
        This is a danger alert—check it out!
        <a href="#" class="alert-link">Fixing it now</a>
        <ul><li>Title  is required.</li><li>Salary  is required.</li><li>Position classification  is required.</li><li>Skills and knowledge  is required.</li></ul>
        </div>
        <div class="alert alert-warning alert-dismissible fade show" role="alert">
        <i class="gel-icon-warning" aria-hidden="true"></i>
        You should check in on some of those fields below.
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <i class="gel-icon-close gel-icon-lg" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <section class="md" v-html="alertMd"></section>

  </section>
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
import notMd from "@/docs/components/notification.md";
import alertMd from "@/docs/components/alert.md";
export default {
  name: "alerts",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.alerts.name);
    this.$emit("update-tagline", this.$root.yamlData.components.alerts.description);
  },
  mounted: function () {
    const closeAlerts = document.querySelectorAll('[data-dismiss="alert"]')
    closeAlerts.forEach(alert => {
      new BSN.Alert(alert)
    })
  },
  data() {
    return {
      notMd, alertMd
    };
  }
};
</script>
